import React from "react";
import { Link } from "react-router-dom";

export default function NavItem({
    label,
    href = "#",
    icon,
    rootClass = '',
    inHeader = false,
    inFooter = false,
}: {
    label: string;
    href?: string;
    icon: StaticImageData;
    rootClass?: string;
    inHeader?: boolean;
    inFooter?: boolean;
}) {
    if (inHeader) {
        return (
            <Link to={href} className="site-header__nav-link is-desktop">
                <img src={icon} alt="" />
                <span className="whitespace-nowrap">{label}</span>
            </Link>
        );
    }

    if (inFooter) {
        return (
            <Link to={href} className="site-footer__nav-link">
                <img src={icon} alt="" />
                <span className="whitespace-nowrap">{label}</span>
            </Link>
        );
    }

    return (
        <Link to={href} className={`flex h-10 items-center justify-center gap-1.5 rounded-md p-2.5 text-sm font-normal leading-6 text-slate-100 transition hover:bg-white/10 ${rootClass}`}>
            <img src={icon} alt="" />
            <span className="whitespace-nowrap">{label}</span>
        </Link>
    );
}
